import { useState } from 'react';

interface IFadeOutData {
    isFadeOutStarted: boolean;
    startFadeOut: (callback: () => void) => void;
}
export const useFadeOut = (duration: number): IFadeOutData => {
	const [isFadeOutStarted, setIsFadeOutStarted] = useState<boolean>(false);

	const startFadeOut = (callback: () => void): void => {
		setIsFadeOutStarted(true);
		setTimeout(() => {
			callback();
		}, duration);
	};

	return { isFadeOutStarted, startFadeOut };
};
